<script setup lang="ts">
export interface IDSKNavProps {
  items: ReadonlyArray<LinkItemProps>
  mobileOpened?: boolean
}
export interface LinkItemProps {
  title: string
  href: string
  insideAppLink: boolean
  target?: string
}

import { CLASS_ROOT } from './constants'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const props = withDefaults(defineProps<IDSKNavProps>(), {
  items: () => [],
  mobileOpened: false,
})

const isActive = (href: string) => {
  return route.path.match(new RegExp(`^${href}`))
}
</script>

<template>
  <div
    :class="[
      `${CLASS_ROOT}__nav`,
      {
        [`${CLASS_ROOT}__nav--mobile`]: !props.mobileOpened,
      },
    ]"
  >
    <IDSKContainer>
      <IDSKRow>
        <IDSKCol />
        <IDSKCol>
          <nav :class="`${CLASS_ROOT}__nav-bar--buttons`">
            <ul :class="`${CLASS_ROOT}__nav-list`" :aria-label="t('aria-label')">
              <li
                v-for="item in props.items"
                :key="item.href"
                :class="[
                  `${CLASS_ROOT}__nav-list-item`,
                  {
                    [`${CLASS_ROOT}__nav-list-item--active`]: isActive(item.href),
                  },
                ]"
              >
                <router-link
                  v-if="item.insideAppLink"
                  v-slot="{ href: hrefValue, navigate }"
                  custom
                  :to="item.href"
                >
                  <IDSKLink
                    :class="`${CLASS_ROOT}__nav-list-item-link`"
                    :href="hrefValue"
                    :title="item.title"
                    :target="item.target"
                    :data-test-id="'nav-link' + '-' + hrefValue"
                    @click="navigate"
                  >
                    {{ item.title }}
                  </IDSKLink>
                </router-link>
                <a
                  v-else
                  target="_blank"
                  :class="`${CLASS_ROOT}__nav-list-item-link`"
                  :href="item.href"
                  >{{ item.title }}</a
                >
              </li>
            </ul>
          </nav>
        </IDSKCol>
      </IDSKRow>
      <IDSKRow>
        <IDSKCol>
          <div :class="`${CLASS_ROOT}__main--buttons`">
            <div :class="`${CLASS_ROOT}__main--login`">
              <Prihlasenie />
            </div>
          </div>
        </IDSKCol>
      </IDSKRow>
    </IDSKContainer>
  </div>
</template>

<style scoped lang="scss">
.idsk-header-web__nav-list {
  padding-bottom: 0;
  margin-left: 0;
  margin-right: 0;
}
.idsk-header-web__nav-list-item {
  // display: inline-block;
  background: transparent;

  .idsk-header-web__nav-list-item-link,
  .idsk-header-web__nav-list-item-link:visited {
    padding-left: 15px;
    padding-right: 15px;

    &:hover {
      color: #0065b3;
      background: #0065b30f;
    }

    @media screen and (min-width: 768px) {
      padding-bottom: 15px;
    }
  }

  &--active {
    .idsk-header-web__nav-list-item-link,
    .idsk-header-web__nav-list-item-link:visited {
      font-weight: 700;
      text-decoration: underline;
      color: #0065b3;
    }
  }
}
</style>

<i18n lang="yaml">
sk:
  aria-label: 'Hlavná navigácia'
</i18n>
